import { render, staticRenderFns } from "./CustomerReports.vue?vue&type=template&id=736ce145&"
import script from "./CustomerReports.vue?vue&type=script&lang=js&"
export * from "./CustomerReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports